<div [appIsLoading]="loadingService.isLoading(this, 'league')">
    <div *ngIf="league && league.textForAboveLeague" [innerHtml]="league.textForAboveLeague | sanitizeHtml"></div>
    <cs-shared-league-page *ngIf="league" [salesAchievementLevel]="league.salesAchievementLevel"
        [winningPosition]="league.winningPositions" [attributes]="league.selectedColumns" [leagueData]="league.items"
        [isHubComponent]="true" [showTableTitle]="true">
    </cs-shared-league-page>
    <div *ngIf="league && league.textForBelowLeague" [innerHtml]="league.textForBelowLeague | sanitizeHtml"></div>
</div>